export default __webpack_public_path__ + "static/media/gallery_03.0f2d11a6.jpg";